import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import Text from "../../../commons/Text";

export default function List({ list }) {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <ul className={classes.list}>
          {list.map((item) => (
            <li key={uuid()} className={classes.item}>
              <div className={classes.image}>
                <picture>
                  <source srcSet={item.images.webp} type="image/webp" />
                  <source srcSet={item.images.png} type="image/png" />
                  <img
                    srcSet={item.images.png}
                    alt={item.title}
                    width={80}
                    height={80}
                  />
                </picture>
              </div>
              <div className={classes.content}>
                <h3 className={classes.title}>{item.title}</h3>
                <Text className={classes.text} text={item.text} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
